import React from 'react'

const Home = React.lazy(() => import('./views/home/Home'))
const Greeting = React.lazy(() => import('./views/intro/Greeting'))
const BusinessInfo = React.lazy(() => import('./views/intro/BusinessInfo'))
const Agency = React.lazy(() => import('./views/intro/Agency'))
const Performance = React.lazy(() => import('./views/intro/Performance'))

const Data = React.lazy(() => import('./views/data/Data'))
const DataList = React.lazy(() => import('./views/data/DataList'))
const DataDetail = React.lazy(() => import('./views/data/DataDetail'))

const Notice = React.lazy(() => import('./views/board/Notice'))
const NoticeDetail = React.lazy(() => import('./views/board/NoticeDetail'))

const ContactUs = React.lazy(() => import('./views/board/Inquiry'))
const ContactUsDetail = React.lazy(() => import('./views/board/InquiryDetail'))

//메인
// const Home = React.lazy(() => import('./views/home/Home'))
//로그인
const login = React.lazy(() => import('./views/login/Login'))
const passwordChange = React.lazy(() => import('./views/login/PasswordChange'))
const findIdPw = React.lazy(() => import('./views/login/FindIdPw'))
const findIdPwResult = React.lazy(() => import('./views/login/FindIdPwResult'))
const Mypage = React.lazy(() => import('./views/myInfo/MyInformation'))
//회원가입
const terms = React.lazy(() => import('./views/signUp/Terms'))
const signUp = React.lazy(() => import('./views/signUp/SignUp'))
//소개
// const Intro = React.lazy(() => import('./views/intro/Intro'))
//게시판
// const Notice = React.lazy(() => import('./views/board/Notice'))

// AI S/W목록
const MarketList = React.lazy(() => import('./views/market/MarketList'))
const MarketPage = React.lazy(() => import('./views/market/MarketPage'))
const MarkerDetail = React.lazy(() => import('./views/market/MarketDetail'))
const MarketWrite = React.lazy(() => import('./views/market/MarketWrite'))


//안신분석구역
const SafeAnalysisZone = React.lazy(() => import('./views/safe-zone/SafeAnalysisZoneInfo'))
const Useprocedure = React.lazy(() => import('./views/safe-zone/Useprocedure'))
const SafeAnalysisZoneWrite = React.lazy(() => import('./views/safe-zone/SafeAnalysisZoneWrite'))
const SafeAnalysisZoneList = React.lazy(() => import('./views/safe-zone/SafeAnalysisZoneList'))
const SafeAnalysisZoneDetail = React.lazy(() => import('./views/safe-zone/SafeAnalysisZoneDetail'))
//.js
const ScreeningWrite = React.lazy(() => import('./views/screening/ScreeningWrite'))
const ScreeningDetail = React.lazy(() => import('./views/screening/ScreeningDetail'))

// 뷰어
const Viewer = React.lazy(() => import('./layout/ViewerLayout'))


const routes = [
  { path: '/', exact: true, name: '', component: Home },
  { path: '/intro', exact: true, name: 'greeting', component: Greeting },
  { path: '/intro/greeting', exact: true, name: 'greeting', component: Greeting },
  { path: '/intro/businessInfo', exact: true, name: 'businessInfo', component: BusinessInfo },
  { path: '/intro/agency', exact: true, name: 'agency', component: Agency },
  { path: '/intro/performance', exact: true, name: 'performance', component: Performance },

  { path: '/data', exact: true, name: 'data', component: Data },
  { path: '/data/List', exact: true, name: 'dataList', component: DataList },
  { path: '/data/list/detail', exact: true, name: 'dataDetail', component: DataDetail },

  { path: '/board', exact: true, name: 'notice', component: Notice },
  { path: '/board/notice', exact: true, name: 'notice', component: Notice },
  { path: '/board/NoticeDetail', exact: true, name: 'NoticeDetail', component: NoticeDetail },
  { path: '/board/contactus', exact: true, name: 'Inquiry', component: ContactUs },
  { path: '/board/contactus/:bbsId', exact: false, name: 'InquiryDetail', component: ContactUsDetail },

  { path: '/auth/login*', exact: true, name: 'login', component: login },
  { path: '/auth/terms', exact: true, name: 'terms', component: terms },
  { path: '/auth/signUp', exact: true, name: 'signUp', component: signUp },
  { path: '/auth/pwd', exact: true, name: 'pwd', component: passwordChange },
  { path: '/auth/find', exact: true, name: 'find', component: findIdPw },
  { path: '/auth/result', exact: true, name: 'result', component: findIdPwResult },
  { path: '/auth/mypage', exact: true, name: 'mypage', component: Mypage },
  
  { path: '/market', exact: true, name: 'MarketList', component: MarketList },
  { path: '/market/list', exact: true, name: 'MarketList', component: MarketList },
  { path: '/market/detail', exact: true, name: 'MarkerDetail', component: MarketPage },
  { path: '/market/write', exact: true, name: 'MarketWrite', component: MarketPage },
  { path: '/market/modify', exact: true, name: 'MarkerModify', component: MarketPage },
  
  { path: '/safe-zone/info', exact: true, name: 'SafeAnalysisZone', component: SafeAnalysisZone },
  { path: '/safe-zone/procedure', exact: true, name: 'Useprocedure', component: Useprocedure },
  { path: '/safe-zone/write', exact: true, name: 'SafeAnalysisZoneWrite', component: SafeAnalysisZoneWrite },
  { path: '/safe-zone/list', exact: true, name: 'SafeAnalysisZoneList', component: SafeAnalysisZoneList },
  { path: '/safe-zone/:id', exact: false, name: 'SafeAnalysisZoneDetail', component: SafeAnalysisZoneDetail },
  
  { path: '/screening/write', exact: false, name: 'ScreeningWrite', component: ScreeningWrite },
  { path: '/screening/:id', exact: false, name: 'ScreeningDetail', component: ScreeningDetail },

  { path: '/viewer/:id', exact: false, name: 'Viewer', component: Viewer },
  
]

export default routes
